import { connect } from 'react-redux'

import CustomMessage from './component'

import * as orgSelectors from 'modules/org/selectors'
import * as userSelectors from 'modules/user/selectors'

const mapStateToProps = state => ({
  welcomeMessage: orgSelectors.getWelcomeMessage(state),
  email: userSelectors.getEmail(state),
  name: userSelectors.getName(state),
  color: orgSelectors.getColor(state),
  locale: orgSelectors.getLocale(state),
  user: state.user
})

export default connect(mapStateToProps)(CustomMessage)


// WEBPACK FOOTER //
// ./src/layouts/CustomMessage/index.js